import Dropdown from "app/components/Dropdown";
import { SortingFilterIcon } from "app/components/Icons";
import CustomTooltip from "app/components/Tooltip";
import React, { useState } from "react";
import SelectedShorting from "./SelectedShorting";
import { getShortIcon } from "./data";
import { SortingControlProps } from "./types";

export default function SortingControl({
  fields,
  rules,
  draggedIndex,
  onAddRule,
  onRemoveRule,
  onUpdateField,
  onUpdateOrder,
  onReorder,
  onClearRules,
  onUpdateDraggedIndex,
}: SortingControlProps) {
  const [isOpen, setIsOpen] = useState(false);

  const filledRules = rules.filter((r) => r.fieldKey !== null);

  const menuItems = fields
    .filter((f) => !rules.some((r) => r.fieldKey === f.key)) // already used fields hide karo
    .map((opt) => ({
      label: (
        <div className="flex items-center gap-2">
          {getShortIcon(opt.key)}
          <span className="text-sm font-normal text-secondary">
            {opt.label}
          </span>
        </div>
      ),
      action: () => {
        onAddRule(opt.key);
        setIsOpen(false);
      },
    }));

  return (
    <div className="relative">
      {filledRules.length > 0 ? (
        <SelectedShorting
          fields={fields}
          rules={rules}
          draggedIndex={draggedIndex}
          onRemoveRule={onRemoveRule}
          onUpdateField={onUpdateField}
          onUpdateOrder={onUpdateOrder}
          onReorder={onReorder}
          onClearRules={onClearRules}
          onUpdateDraggedIndex={onUpdateDraggedIndex}
        />
      ) : (
        <Dropdown
          open={isOpen}
          setOpen={setIsOpen}
          trigger={
            <button
              className={`w-8 h-8 px-2 flex items-center justify-center bg-white hover:bg-gray-400 rounded outline-none ${
                isOpen ? "border border-secondary" : "border border-[#E9ECF2]"
              }`}
            >
              <CustomTooltip text="Sort by" position="bottom">
                <SortingFilterIcon />
              </CustomTooltip>
            </button>
          }
          projectInfoIcon={
            <div className="flex items-center justify-between px-4 py-3 text-secondary text-sm font-medium border-b border-gray-100">
              Sort by
            </div>
          }
          align="start"
          menuItems={menuItems}
        />
      )}
    </div>
  );
}
